module.exports = __webpack_public_path__ + "static/img/Slide-3.c5e33f4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-3.webp
// module id = w4XP
// module chunks = 0